import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { HeaderActionItemComponent } from '@shared/components/header-action-item/header-action-item.component';
import { MatDialogModule} from '@angular/material/dialog';

@NgModule({
  declarations: [
    HeaderActionItemComponent,

  ],
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MatDialogModule
  ],
  exports: [
    HeaderActionItemComponent
  ]
})
export class HeaderActionItemModule { }
